/**
 * api接口统一管理
 */
import { get,get1, post, postJson, postForm,get2,get3  } from './http'
//车系接口
export const getFileBlom = p => get(url, p) //删除传感器类型检测项参考值
export const logins = p => post('user/login', p) //修改传感器类型检测项参考值
export const addreply = p => post('complain/addreply', p) //修改传感器类型检测项参考值
export const car_series = p => post('carkind/getclasslist', p);
export const car_series_add = p => postJson('carkind/addclass', p);
export const car_series_updata = p => postJson('carkind/updateclass', p);
export const car_series_all = p => post('carkind/getallcarclass', p);
//车组接口
export const car_group = p => post('carkind/getgrouplist', p);
export const car_group_add = p => postJson('carkind/addgroup', p);
export const car_group_updata = p => postJson('carkind/updategroup', p);
export const car_group_all = p => post('carkind/getgroupbyclassid', p);
//车型接口
export const car_kind = p => post('carkind/getkindlist', p);
export const car_kind_add = p => postJson('carkind/addcarkind', p);
export const car_kind_updata = p => postJson('carkind/updatecarkind', p);
export const car_kind_all = p => post('carkind/getkindbygroupid', p);
export const delcarkind = p => post('carkind/delcarkind', p);
//车型文件接口
export const car_kindFile = p => post('carkind/getkindfilelist', p);
export const car_kindFile_add = p => post('carkind/addkindfile', p);
export const car_kindFile_updata = p => post('carkind/updatekindfile', p);
export const car_kindFile_audit = p => post('carkind/auditkindfile', p);
export const car_kindFile_publish = p => post('carkind/publishkindfile', p);
export const cancelPublishkindfile = p => post('carkind/cancelPublishkindfile', p);
//车标类型接口
export const car_icon = p => post('caricon/getCarIconTypeList', p);
export const car_icon_add = p => post('caricon/addCarIconType', p);
export const editCarIconType = p => post('caricon/editCarIconType', p);
//车标文件接口
export const car_iconFile = p => post('caricon/getCarIconFilePage', p);
export const car_iconFile_add = p => post('caricon/addCarIconFile', p);
export const car_iconFile_updata = p => post('caricon/updateCarIconFile', p);

//设备接口
//售机类型列表
export const equip_type = p => post('productclass/getall', p);
//获取设备类型列表(去掉重复路径)
export const equip_type_unique = p => post('productclass/getUniquePath', p);

//获取设备机型列表
export const equip_model = p => post('productinfo/getProductInfoPage', p);
//添加设备机型
export const equip_model_add = p => post('productinfo/addProductInfo', p);
//编辑设备机型
export const equip_model_updata = p => post('productinfo/updateProductInfo', p);
//删除设备机型
export const equip_model_remove = p => post('product/delProductInfo', p);
//获取设备机型的授权车型列表
export const authoriz_carModel = p => post('ckproductinfo/getAuthCarKind2ProductInfo', p);
//获取设备机型的未授权车型列表
export const unauthoriz_carModel = p => post('ckproductinfo/getUnauthCarKind2ProductInfo', p);
//给设备机型授权车型
export const unauthoriz_authoriz = p => post('ckproductinfo/authCarKind2ProductInfo', p);
//修改给设备机型授权车型
export const authoriz_updata = p => post('ckproductinfo/updateCarIcon2ProductInfo', p);
//删除给设备机型授权车型
export const delCarIcon2ProductInfo = p => post('ckproductinfo/delCarIcon2ProductInfo', p);
//给拓展文件授权
//获取设备机型的授权与未授权车型列表
export const authoriz_expandFile = p => post('extfile/getExtFileInfo2ProductInfoPage', p);
//给设备机型授权车型
export const unauthoriz_authoriz_expand = p => post('extfile/authExtFileInfo2ProductInfo', p);






//获取用户设备
export const equip_user = p => post('productall/getPadProduct', p);
//批量添加用户设备
export const equip_add_batch = p => post('productall/batchAddProduct', p);

export const equip_add__old = p => post('productall/batchAddAppOldVciProduct', p);
//修改用户设备
export const equip_user_updata = p => post('productall/updateMemberProduct', p);
//获取手机设备
export const mobile_equip = p => post('productall/getAppProduct', p);
//批量添加手机设备
export const mobile_add_batch = p => post('productall/batchAddAppProduct', p);
//修改手机设备
export const mobile_user_updata = p => post('productall/updateAppProduct', p);






//商用车车型数据包列表
export const model_dataPackage = p => post('dieseldata/getFileList', p);

//语言接口
//获取语言列表
export const language_list = p => post('lang/getlang', p);
//获取语言和所有项列表
export const language_list_all = p => post('lang/getlangandall', p);
//获取所有语言列表
export const all_language_list = p => post('lang/getalllang', p);
//获取所有语言列表(包含all项)
export const all_language_list_all = p => post('lang/getalllangandallitem', p);


//经销商接口
export const dealer_list = p => post('clienttrader/getallinfo', p);
export const dealer_list_add = p => post('dieseldata/addFileInfo', p);
export const dealer_list_updata = p => post('dieseldata/updateFileInfo', p);
export const dealer_list_publis = p => post('dieseldata/publishFile', p);
export const dealer_list_out = p => post('dieseldata/withdrawFile', p);
export const dealer_list_remove = p => post('dieseldata/delFileInfo', p);


//拓展包接口
//文件信息
export const fileInfo_list = p => post('extfile/getExtFileInfoPage', p);
export const fileInfo_all = p => post('extfile/getExtFileInfoList', p);

export const fileInfo_list_add = p => post('extfile/addExtFileInfo', p);
export const fileInfo_list_updata = p => post('extfile/updateExtFileInfo', p);


//文件版本
export const fileVersion_list = p => post('extfile/getExtFileInfoVersion', p);
export const fileVersion_list_add = p => post('extfile/addExtFileInfoVersion', p);
export const fileVersion_updata = p => post('extfile/updateExtFileInfoVersion', p);
export const fileVersion_audit = p => post('extfile/auditExtFileInfoVersion', p);
export const fileVersion_publish = p => post('extfile/publishExtFileInfoVersion', p);

//通用文件

export const languagefile_list = p => post('otherfile/findFileTypeLangPage', p); //获取文件类型语言信息(分页)
export const languagefile_add = p => post('otherfile/addFileTypeLang', p); //新增文件类型语言信息
export const languagefile_updata = p => post('otherfile/updateFileTypeLang', p); //获取文件类型语言信息(分页)
export const TypeLang_list = p => post('otherfile/getTypeLangList', p); //获取文件类型授权列表(分页)
export const TypeLang_auth = p => post('otherfile/authFileTypeToProductInfo', p); //授权文件类型

export const filelanguage_list = p => post('otherfile/findFileTypeLangList', p); //获取文件类型语言信息
export const otherfile_list = p => post('otherfile/findFileTypePage', p); //分页列表
export const otherfile_list_id = p => post('otherfile/findFileTypeList', p); //id
export const otherfile_add = p => post('otherfile/addFileType', p); //文件类型添加
export const otherfile_update = p => post('otherfile/updateFileType', p) //文件类型修改
export const otherfile_ver_list = p => post('otherfile/findFileOtherDownPage', p)
export const otherfile_ver_add = p => post('otherfile/addFileOtherDown', p) //文件版本添加
export const otherfile_ver_update = p => post('otherfile/updateFileOtherDown', p) //文件版本修改
export const otherfile_ChildPage = p => post('otherfile/findFileOtherDownChildPage', p) //子文件版本列表
export const ChildPage_add = p => post('otherfile/addFileOtherDownChild', p) //子文件版本列表
export const ChildPage_update = p => post('otherfile/updateFileOtherDownChild', p) //子文件版本列表
export const addFileTypeVerLog = p => post('otherfilelog/addFileTypeVerLog', p) //增加文件类型版本升级说明
export const findFileTypeVerLogPage = p => post('otherfilelog/findFileTypeVerLogPage', p) //获取文件类型版本升级说明(分页)
export const updateFileTypeVerLog = p => post('otherfilelog/updateFileTypeVerLog', p) //修改文件类型版本升级说明
export const findChildType = p => post('otherfile/findChildType', p) //子类型ID


export const brand_list = p => post('hwdieselcar/findPage', p) //品牌列表
export const brand_add = p => post('hwdieselcar/addHwDieselAllCar', p) //新增品牌

export const brand_unauth_list = p => post('hwdieselcar/getUnauthHwDieselCar2ProductInfo', p) //未授权品牌列表
export const brand_auth_list = p => post('hwdieselcar/getAuthHwDieselCar2ProductInfo', p) //已授权品牌列表

export const brand_auth = p => post('hwdieselcar/authHwDieselCar2ProductInfo', p) //未授权品牌授权
export const brand_unauth = p => post('hwdieselcar/deleteAuthHwDieselCar2ProductInfo', p) //已授权品牌取消授权


export const getallinfo = p => post('clienttrader/getallinfo', p) //分页获取经销商列表
export const findRegionPage = p => post('clienttrader/findRegionPage', p) //分页获取经销商销售区域
export const updateTraderRegion = p => post('clienttrader/updateTraderRegion', p) //修改经销商区域
export const findExpRegionPage = p => post('downregion/findExpRegionPage', p) //分页获取设备异常访问记录
export const delExpRegion = p => post('downregion/delExpRegion', p) //删除设备异常访问记录
export const setProductStatus = p => post('productall/setProductStatus', p) //设置设备状态
export const getAuthRegion2Sn = p => post('downregion/getAuthRegion2Sn', p) //已授权区域列表
export const getUnauthRegion2Sn = p => post('downregion/getUnauthRegion2Sn', p) //未授权区域列表
export const authRegion2Sn = p => post('downregion/authRegion2Sn', p) //授权区域
export const delRegion2Sn = p => post('downregion/delRegion2Sn', p) //取消授权区域
export const gettraderPage = p => post('clienttrader/getPage', p) //获取经销商列表
export const updateLockAuth = p => post('clienttrader/updateLockAuth', p) //修改经销商锁机权限


// F8 Pro系统管理

export const getOssToken = p => post('/oss/getOss', p) //获取检测类型的列表
export const getCheckTypeList = p => post('checktype/getlist', p) //获取检测类型的列表
export const searchCarbrand = p => post('carbrand/search', p) //查询汽车品牌列表
export const addCarbrand = p => post('carbrand/add', p) //添加汽车品牌列表
export const updateCarbrand = p => post('carbrand/update', p) //修改汽车品牌列表

export const searchCarkind = p => post('f8carkind/search', p) //查询车型列表
export const updatef8carkind = p => post('f8carkind/update', p) //修改车型
export const addf8carkind = p => post('f8carkind/add', p) //修改车型
export const delf8carkind = p => post('f8carkind/del', p) //修改车型


export const searchCarbrandByType = p => post('carbrand/search', p) //获取某检测类型的汽车品牌列表
export const addCarkind = p => post('carkind/add', p) //添加车型信息

export const searchSensorBrand = p => post('sensor/searchbrand', p) //添加传感器品牌的列表
export const addSensorBrand = p => post('sensor/addbrand', p) //添加传感器品牌的列表
export const updateSensorBrand = p => post('sensor/updatebrand', p) //添加传感器品牌的列表

export const searchSensortype = p => post('sensortype/search', p) //添加传感器类型的列表
export const searchitem = p => post('sensortype/searchitem', p) //添加传感器类型的列表
export const addsenSortype = p => post('sensortype/add', p) //添加传感器类型的列表
export const updateSensortype = p => post('sensortype/update', p) //添加传感器类型的列表
export const addCheckitem = p => post('sensortype/additem', p) //添加传感器类型的列表
export const updateCheckitem = p => post('sensortype/updateitem', p) //修改传感器类型
export const delsenSortype = p => post('sensortype/del', p) //修改传感器类型
export const deleCheckitem = p => post('sensortype/delitem', p) //修改传感器类型

export const searchSensor = p => post('sensor/search', p) //查询传感器列表
export const updateSensor = p => postJson('sensor/update', p) //修改传感
export const delSensor = p => post('sensor/del', p) //删除传感
export const delSensoritem = p => post('sensor/delitem', p) //删除传感检测
export const addSensor = p => postJson('sensor/add', p) //增加传感器
export const addSensoritem = p => post('sensor/additem', p) //增加传感器检测项
export const updateSensoritem = p => post('sensor/updateitem', p) //增加传感器检测项
export const getSensorFuncItemByid = p => post('sensor/getSensorFuncItemByid', p) //增加传感器检测项


//投诉
export const appeal_list = p => post('complain/getlist', p) //查询投诉列表
export const complain = p => post('complain/findattachbycomplain', p);

export const updateChandao = p => post('complain/updatezentao', p);

//计算时间差
export function DateMinus(date1, date2) { //date1:小日期   date2:大日期
  var sdate = new Date(date1);
  var now = new Date(date2);
  var days = now.getTime() - sdate.getTime();
  var day = parseInt(days / (1000 * 60 * 60 * 24));
  return day;
}


export const searchitemval = p => post('sensortype/searchitemval', p) //查询参考值列表
export const additemval = p => postJson('sensortype/additemval', p) //增加传感器类型检测项参考值接口
export const updateitemval = p => postJson('sensortype/updateitemval', p) //修改传感器类型检测项参考值
export const delitemval = p => get('sensortype/delitemval', p) //删除传感器类型检测项参考值
export const auditsensor = p => post('data/auditsensor', p) //改变状态
export const querySensorData = p => post('data/querysensor', p) //查询上传数据列表
export const addCarIconFile = p => postJson('caricon/addCarIconFile', p) //修改传感器类型检测项参考值

export const findPinfoAuthcontrolPage = p => post('pinfoAuthcontrol/findPinfoAuthcontrolPage', p) //获取售机类型权限限制列表(分页)
export const setProductinfoAuthcontrol = p => post('pinfoAuthcontrol/setProductinfoAuthcontrol', p) //设置售机类型权限限制
export const findPinfoAuthcontrolProductPage = p => post('pinfoAuthcontrol/findPinfoAuthcontrolProductPage', p) //获取设备权限限制授权列表(分页)
export const setAuthcontrolProduct = p => post('pinfoAuthcontrol/setAuthcontrolProduct', p) //为设备设置售机类型权限限制



/*3D定位仪*/
export const findPriceset = p => post('/pricesetManager/findPriceset', p) //套餐列表
export const addPriceset = p => post('/pricesetManager/addPriceset', p) //新增套餐
export const editPriceset = p => post('/pricesetManager/editPriceset', p) //编辑套餐
export const updatePriceStatus = p => post('/pricesetManager/updatePriceStatus', p) //编辑套餐状态
// export  const  productclassGetall = p => post('/productclass/getall', p) //设备类型列表
export const productclassGetall = p => post('/pricesetManager/getProductScope', p) //设备类型列表
export const getProductInfoList = p => post('/productinfo/getProductInfoList', p) //设备型号列表


export const findClientInfo = p => get('/clientInfoManager/findClientInfo', p) //客户列表
export const editClientInfo = p => post('/clientInfoManager/editClientInfo', p) //修改客户列表
export const findClientInfoDevice = p => get('/clientInfoManager/findClientInfoDevice', p) //关联客户设备
export const findClientInfoOrder = p => get('/clientInfoManager/findClientInfoOrder', p) //关联客户订单
export const findStatusByLog = p => get('/clientInfoManager/findStatusByLog', p) //关联客户修改记录
export const sendOverdueReminder = p => get('/clientInfoManager/sendOverdueReminder', p) //短信催单

export const findDevice = p => post('/deviceManager/findDevice', p) //设备列表
export const batchProductSn = p => postJson('/deviceManager/batchProductSn', p) //批量添加序列号
export const findDeviceByLog = p => post('/deviceManager/findDeviceByLog', p) //设备修改记录列表
export const findProvince = p => get('/provinceManager/findProvince', p) //地区管理
export const updateDeviceInfo = p => postJson('/deviceManager/updateDeviceInfo', p) //设备修改
export const updateDeviceDate = p => postForm('/deviceManager/updateDeviceDate', p) //修改设备授权期限
export const unbindDevice = p => postJson('/deviceManager/unbindDevice', p) //解绑设备
export const updateDeviceSn = p => postJson('/deviceManager/updateDeviceSn', p) //修改设备序列号
export const findRegionPage2 = p => post('/downregion/findRegionPage', p) //国家区域列表
export const getRegionBySn = p => post('/downregion/getRegionBySn', p) // 获取设备下载区域



export const findClientOrder = p => post('/orderManager/findClientOrder', p) //订单列表


export const findClientDeviceLog = p => post('/clientDeviceLogManager/findClientDeviceLog', p) //异常日志列表


export const findDeviceFix = p => post('/DeviceFixManager/findDeviceFix', p) //保修故障列表
export const findFaultType = p => get('/DeviceFixManager/findFaultType', p) //保修故障类型列表
export const addDeviceFix = p => postJson('/DeviceFixManager/addDeviceFix', p) //上报故障
export const editDeviceFix = p => postJson('/DeviceFixManager/editDeviceFix', p) //故障审批




export const findE8regionSnPage = p => post('/e8region/findE8regionSnPage', p) //获取E8设备列表
export const getE8regions = p => post('/e8region/getE8regions', p) //获取E8设备列表
export const getE8regionForSn = p => post('/e8region/getE8regionForSn', p) //获取E8设备列表
export const setE8regionForSn = p => post('/e8region/setE8regionForSn', p) //获取E8设备列表
export const getGoodsCoinByid = p => post('/material/mall/getGoodsCoinByid', p) //获取E8设备列表
export const adjustPushPatch = p => post('/algo/adjustPushPatch', p) //http://192.168.3.53:9102

export const productallFindOne = p => post('/productall/findOne', p) //获取E8设备列表>>>>>>> .r17066


export const findTestproduct= p => get('/testproduct/findPage', p) // 分页获取序列号列表
export const delTestproduct= p => get('/testproduct/delTestproduct', p) // 删除序列号
export const addTestproduct= p => get('/testproduct/addTestproduct', p) // 增加序列号




// 设备授权码生成
export const genTruecode= p => get('/regist/genTruecode', p) // 功能码-获取转正码
export const genTrytimesCode= p => get('/regist/genTrytimesCode', p) // 功能码-获取试用次数授权码
export const genTrydaysCode= p => get('/regist/genTrydaysCode', p) // 功能码-获取试用天数授权码
export const genTruecode2= p => get('/regist/genTruecode2', p) // 到期码-获取转正授权码
export const genTrytimesCode2= p => get('/regist/genTrytimesCode2', p) // 到期码-获取延长次数授权码
export const genTrydaysCode2= p => get('/regist/genTrydaysCode2', p) // 到期码-获取延长天数授权码





// 新增
// 
export const exportExpRegionxls = p => get1('/downregion/exportExpRegionxls',p) // 设备异常访问记录导出(查某一序列号要能导出该序列号的全部数据)
export const unboundAppProduct = p => get('/productall/unboundAppProduct',p) // 手机设备序列号解绑
export const getAuthProductInfo2CarkindPage = p => get('/productinfo/getAuthProductInfo2CarkindPage',p) // 车型授权售机类型
export const getUnAuthProductInfo2CarkindPage = p => get('/productinfo/getUnAuthProductInfo2CarkindPage',p) // 车型未授权售机类型
export const getSaleRegion = p => get('/downregion/getSaleRegion',p) // 销售区域
export const findUserUploadPage = p => get('/brush/findUserUploadPage',p) // ECU刷写 
export const findCountry = p => get('/country/findCountry',p) // 获取国家/地区
export const getCarIconTypeByCarKindID = p => get('/caricon/getCarIconTypeByCarKindID',p) // 获取车型车标
export const queryExpRegionxls = p => get2('/downregion/queryExpRegionxls',p) // 获取数据

// 获取维修记录列表
export const recordList = p => post('productrepair/list', p);
export const addRecord = p => post('productrepair/add', p);
export const updateRecord = p => post('productrepair/update', p);
export const delRecord = p => post('productrepair/del', p);


// 设备UI方案列表
export const productUitypeList = p => post('productUitype/list', p);
export const findPage = p => post('productUitype/findPage', p);
// 增加设备UI方案
export const addProductUitype = p => post('productUitype/addProductUitype', p);
// 修改设备UI方案
export const updateProductUitype = p => post('productUitype/updateProductUitype', p);
// 用户列表
export const getUserList = p => post('kmemberinfo/getUserList', p);
// 修改PC软件服务到期日期 
export const updatePcServerLastDate = p => post('kmemberinfo/updatePcServerLastDate', p);
// 操作日志
export const getPage = p => post('sysoptlog/getPage', p);
// ECU故障码
export const ecusafeGetPage = p => post('ecusafe/getPage', p);
// ECU故障码 导入
export const receiveExcel = p => post('ecusafe/batchAdd', p);
//设备ECU违规操作
export const getlist = p => post('pbreakrules/getlist', p);
//设备锁机
export const setProductStatu = p => post('pbreakrules/setProductStatus', p);
//丰汇用户列表
export const getFhuserPage = p => post('fhuser/getPage', p);
//丰汇用户的sn
export const getFhUserSn = p => post('fhuser/getFhUserSn', p);
//分页获取通用应用类型
export const commapptypeList = p => post('commapptype/findPage', p);
//增加通用应用类型
export const addCommapptype = p => post('commapptype/add', p);
//修改通用应用类型
export const updateCommapptype = p => post('commapptype/update', p);
//获取用户设备通用应用
export const getCommappUserSnList = p => post('commappUserSn/getCommappUserSnList', p);
//修改用户设备通用应用
export const updateCommappUserSnList = p => post('commappUserSn/update', p);
//设备序列号、订单序列号增加通用应用
export const batchOrderProduct = p => post('productall/batchOrderProduct', p);
//获取所有的通用应用类型
export const getall = p => post('commapptype/getall', p);
//获取设备通用应用设置
export const getAllCommappSnList = p => post('commappUserSn/getAllCommappSnList', p);
//解绑用户设备通用应用
export const delCommappUserSn = p => post('commappUserSn/del', p);
//车标类型
export const getSysIcontypeList = p => post('ckproductinfo/getSysIcontypeList', p);
//获取所有车组
export const getAllCarGroup = p => post('carkind/getAllCarGroup', p);
//修改拓展功能
export const updateProductInfoFunctionStatus = p => post('productFunction/updateProductInfoFunctionStatus', p);
//车检序列号增加
export const cjProductinfoAdd = p => post('cjProductinfo/add', p);
//车检序列号修改
export const cjProductinfoUpdate = p => post('cjProductinfo/update', p);
//车检序列号删除
export const cjProductinfoDel = p => post('cjProductinfo/del', p);
//车检序列号分页列表
export const cjProductinfoPage = p => post('cjProductinfo/findPage', p);

//F9s获取用户列表
export const user = p => post('f9sadmin/user/findPage', p);
//F9s获取诊断记录列表
export const carcheckrec = p => post('f9sadmin/carcheckrec/findPage', p);
//F9s获取诊断记录详情
export const getDetail = p => post('f9sadmin/carcheckrec/getDetail', p);
//F9s获取车辆列表
export const carinfo = p => post('f9sadmin/carinfo/findPage', p);
//批量更新信息
export const updateProductByExcel = p => postForm('productall/updateProductByExcel', p);

//F9s获取用户列表
export const user2 = p => post('f9sadmin/en/user/findPage', p);
//F9s获取诊断记录列表
export const carcheckrec2 = p => post('f9sadmin/en/carcheckrec/findPage', p);
//F9s获取诊断记录详情
export const getDetail2 = p => post('f9sadmin/en/carcheckrec/getDetail', p);
//F9s获取车辆列表
export const carinfo2 = p => post('f9sadmin/en/carinfo/findPage', p);
//智能钥匙列表
export const findObdPage = p => post('dkey/findObdPage', p);
//智能钥匙列表
export const updateById = p => post('dkey/updateById', p);
//zd618车辆列表
export const queryCarList = p => post('zd618/carmanage/queryCarList', p);
//zd618行程列表
export const queryTrip = p => post('zd618/zdtrip/queryTrip', p);
//获取品牌列表(分页)
export const queryBrandPage = p => post('zd618/car/queryBrandPage', p);
//车型数据版本列表
export const getCarKindDataPage = p => post('carkindData/getCarKindDataPage', p);
//车型数据语言版本列表
export const getCarKindDataLangPage = p => post('carkindData/getCarKindDataLangPage', p);
//车型数据包版本发布
export const publishDataVer = p => post('carkindData/publishDataVer', p);
//车型数据包语言版本发布
export const publishDataLangVer = p => post('carkindData/publishDataLangVer', p);
//批量添加序列号
export const batchUpdateProduct = p => post('productall/batchUpdateProduct', p);


//添加私有协议
export const addProviceprotocol = p => post('proviceprotocol/add', p);
//根据协议ID查询私有协议列表
export const proviceprotocolList = p => post('proviceprotocol/list', p);
//根据协议ID查询私有协议
export const getById = p => post('proviceprotocol/getById', p);
//更新私有协议数据
export const updateProviceprotocol = p => post('proviceprotocol/update', p);
//删除私有协议数据
export const delProviceprotocol = p => post('proviceprotocol/del', p);
//添加数据流协议
export const addDataflow = p => post('dataflow-p/add', p);
//更新数据流协议数据
export const updateDataflow = p => post('dataflow-p/update', p);
//根据私有协议ID查询数据流协议列表
export const dataflowList = p => post('dataflow-p/list', p);
//删除数据流协议数据
export const delDataflow = p => post('dataflow-p/del', p);
//添加特殊匹配目标
export const addSpecialmatch = p => post('specialmatch-dest/add', p);
//根据数据流协议ID查询特殊匹配目标列表
export const specialmatchList = p => post('specialmatch-dest/list', p);
//更新特殊匹配目标数据
export const updateSpecialmatch = p => post('specialmatch-dest/update', p);
//删除特殊匹配目标数据
export const delSpecialmatch = p => post('specialmatch-dest/del', p);
//添加特殊匹配或轮询数据流命令
export const addSpecialdata = p => post('zdp-specialdata-cmd/add', p);
//删除特殊匹配或轮询数据流命令
export const delSpecialdata = p => post('zdp-specialdata-cmd/del', p);
//更新特殊匹配或轮询数据流命令
export const updateSpecialdata = p => post('zdp-specialdata-cmd/update', p);
//添加运算符数据
export const addComputeParam = p => post('compute-param/add', p);
//根据数据流命令ID查询运算符列表
export const computeParamList = p => post('compute-param/list', p);
//删除运算符数据
export const delComputeParam = p => post('compute-param/del', p);
//更新运算符数据
export const updateComputeParam = p => post('compute-param/update', p);

//获取所有车型id和品牌
export const carKindList = p => get('/proviceprotocol/carKindList',p)
//获取所有数据流项列表
export const dataflowitemsList = p => get('/proviceprotocol/dataflowitemsList',p)


//获取四轮定位车型列表
export const getFourWheelCarList = p => post('/productall/getFourWheelCarList',p)
//获取设备授权四轮定位车型列表
export const getFourWheelCarListBysn = p => post('/productall/getFourWheelCarListBysn',p)
//获取四轮定位车型版本列表
export const findfourWheelFileOtherDownChildList = p => post('/otherfile/findfourWheelFileOtherDownChildList',p)


//获取安全算法和故障码调用告警列表
export const getAlarmPage = p => get('/callalgorithmRec/getAlarmPage',p)
//获取安全算法调用记录列表
export const getRecPage = p => get('/callalgorithmRec/getRecPage',p)
//安全算法和故障码调用告警处理
export const handleAlarm = p => get('/callalgorithmRec/handleAlarm',p)
//获取经销商列表
export const findTrader = p => post('/clienttrader/findTrader',p)

//ECU打包方式
export const getPackTypes = p => post('/yzd/ecuinfo/getPackTypes',p)
//ECU所属系统
export const getSysIds = p => post('/yzd/ecuinfo/getSysIds',p)
//ECU列表
export const ecuinfo = p => post('/yzd/ecuinfo/findPage',p)
//新增ECU
export const addecuinfo = p => postJson('/yzd/ecuinfo/add',p)
//修改ECU
export const updateecuinfo = p => postJson('/yzd/ecuinfo/update',p)
//删除ECU
export const deleteecuinfo = p => post('/yzd/ecuinfo/delete',p)
//批量发布ECU(逗号,分隔)
export const batchPublish = p => post('/yzd/ecuinfo/batchPublish',p)


//通过ecuCode获取诊断菜单列表
export const getEcumenuinfosByEcuCode = p => post('/yzd/ecumenuinfo/getEcumenuinfosByEcuCode',p)
//增加诊断菜单
export const addEcumenu = p => postJson('/yzd/ecumenuinfo/add',p)
//修改诊断菜单
export const updateEcumenu = p => postJson('/yzd/ecumenuinfo/update',p)
//删除诊断菜单
export const deleteEcumenu = p => post('/yzd/ecumenuinfo/delete',p)
//获取子诊断菜单列表
export const getChildEcumenuinfos = p => post('/yzd/ecumenuinfo/getChildEcumenuinfos',p)
//获取菜单执行类型
export const getExecType = p => post('/yzd/ecumenuinfo/getExecType',p)



//通过菜单ID获取指令组列表
export const getCmdgroupinfosByMenuId = p => post('/yzd/cmdgroupinfo/getCmdgroupinfosByMenuId',p)
//新增指令组
export const addgroupinfo = p => post('/yzd/cmdgroupinfo/add',p)
//获取指令组执行类型
export const groupgetExecType = p => postJson('/yzd/cmdgroupinfo/getExecType',p)
//修改指令组
export const updategroupinfo = p => post('/yzd/cmdgroupinfo/update',p)
//删除指令组
export const deletegroupinfo = p => post('/yzd/cmdgroupinfo/delete',p)



//通过指令组ID获取诊断指令列表
export const getCmdinfosByGroupId = p => post('/yzd/cmdinfo/getCmdinfosByGroupId',p)
//新增诊断指令
export const addCmdinfos = p => postJson('/yzd/cmdinfo/add',p)
//通过指令ID获取结果解析规则列表
export const getResultrulesByCmdId = p => post('/yzd/resultrule/getResultrulesByCmdId',p)
//修改诊断指令
export const updateCmdinfos = p => postJson('/yzd/cmdinfo/update',p)
//删除诊断指令
export const deleteCmdinfos = p => post('/yzd/cmdinfo/delete',p)
//新增结果解析规则
export const addResultrules = p => postJson('/yzd/resultrule/add',p)
//删除结果解析规则
export const deleteResultrules = p => post('/yzd/resultrule/delete',p)
//修改结果解析规则
export const updateResultrules = p => postJson('/yzd/resultrule/update',p)
//通过指令ID获取数据流解析规则列表
export const getdataflowruleByCmdId = p => post('/yzd/dataflowrule/getResultrulesByCmdId',p)
//新增数据流解析规则
export const adddataflowrule = p => postJson('/yzd/dataflowrule/add',p)
//删除数据流解析规则
export const deletedataflowrule = p => post('/yzd/dataflowrule/delete',p)
//修改数据流解析规则
export const updatedataflowrule = p => postJson('/yzd/dataflowrule/update',p)
//通过指令ID获取故障码解析规则列表
export const getFaultrulesByCmdId = p => post('/yzd/faultrule/getFaultrulesByCmdId',p)
//新增故障码解析规则
export const addFaultrules = p => postJson('/yzd/faultrule/add',p)
//修改故障码解析规则
export const updateFaultrules = p => postJson('/yzd/faultrule/update',p)
//删除故障码解析规则
export const deleteFaultrules = p => post('/yzd/faultrule/delete',p)
//根据解析规则ID获取对应的分支
export const getBranchByRule = p => post('/yzd/resultbranch/getBranchByRule',p)
//编码处理
export const getBitMoveType = p => post('/yzd/faultrule/getBitMoveType',p)
//增加分支
export const addBranchByRule = p => postJson('/yzd/resultbranch/add',p)
//修改分支
export const updateBranchByRule = p => postJson('/yzd/resultbranch/update',p)
//根据分支ID删除
export const delBranchByRule = p => post('/yzd/resultbranch/del',p)
//通过菜单ecuCode获取指令组列表
export const getCmdgroupinfosByEcuCode = p => post('/yzd/cmdgroupinfo/getCmdgroupinfosByEcuCode',p)
//通过指ecuCode获取诊断指令列表
export const getCmdinfosByEcuCode = p => post('/yzd/cmdinfo/getCmdinfosByEcuCode',p)
//故障码读码方式
export const getReadType = p => post('/yzd/faultrule/getReadType',p)
//保存指令组顺序
export const saveOrder = p => postJson('/yzd/cmdgroupinfo/saveOrder',p)
//保存指令在组内的顺序
export const savecmdOrder = p => postJson('/yzd/cmdinfo/saveOrder',p)
//获取指令类型
export const getCmdType = p => postJson('/yzd/cmdinfo/getCmdType',p)
//获取菜单功能类型
export const getFunType = p => post('/yzd/ecumenuinfo/getFunType',p)
//依赖列表
export const getDependList = p => post('/yzd/cmdgroupinfo/getDependList',p)
//保存菜单顺序
export const savemenuOrder = p => postJson('/yzd/ecumenuinfo/saveOrder',p)
//获取未写序列号vci列表(分页)
export const findVciPage = p => get('/productVci/findVciPage',p)
//增加未写序列号vci设备
export const addVciPage = p => get('/productVci/add',p)
//vci重新写序列号设置
export const setRewrite = p => get('/productVci/setRewrite',p)
//故障码查询列表
export const faultinfo = p => post('/yzd/faultinfo/findPage',p)
//添加故障码
export const addfaultinfo = p => postJson('/yzd/faultinfo/add',p)
//批量添加故障码
export const batchAddfaultinfo = p => postJson('/yzd/faultinfo/batchAdd',p)
//删除故障码
export const delfaultinfo = p => post('/yzd/faultinfo/del',p)
//批量删除故障码
export const batchDel = p => post('/yzd/faultinfo/batchDel',p)
//修改故障码
export const updatefaultinfo = p => postJson('/yzd/faultinfo/update',p)
//获取售机类型授权子通道列表
export const listProductInfoOtherdownchildtype = p => get2('/otherfile/listProductInfoOtherdownchildtype',p)
//售机类型-授权-子通道
export const authProductInfoOtherdownchildtype = p => get2('/otherfile/authProductInfoOtherdownchildtype',p)
//售机类型-取消-子通道授权
export const unauthProductInfoOtherdownchildtype = p => get2('/otherfile/unauthProductInfoOtherdownchildtype',p)
//自动扫描ECU方式列表
export const ecuscantypefindPage = p => post('/yzd/ecuscantype/findPage',p)
//新增自动扫描ECU方式
export const addecuscantype = p => postJson('/yzd/ecuscantype/add',p)
//修改自动扫描ECU方式
export const updateecuscantype = p => postJson('/yzd/ecuscantype/update',p)
//删除自动扫描ECU方式
export const delecuscantype = p => post('/yzd/ecuscantype/del',p)
//查询自动扫描ECU方式的结果匹配列表
export const queryListByTypeId = p => post('/yzd/ecuscantyperesult/queryListByTypeId',p)
//新增自动扫描ECU方式的结果匹配信息
export const addecuscantyperesult = p => postJson('/yzd/ecuscantyperesult/add',p)
//修改自动扫描ECU方式的结果匹配信息
export const updateecuscantyperesult = p => postJson('/yzd/ecuscantyperesult/update',p)
//删除自动扫描ECU方式的结果匹配信息
export const delecuscantyperesult = p => post('/yzd/ecuscantyperesult/del',p)
//日志文件解密
export const logDecrypt = p => post('/complain/logDecrypt',p)
//获取诊断过程记录列表
export const queryDiagnosislogPage = p => post('/yzd/diagnosislog/queryDiagnosislogPage',p)
//导出：诊断过程记录
export const exportDiagnosislog = p => get3('/yzd/diagnosislog/exportDiagnosislog',p)
//获取字典明细项
export const getDictItems = p => post('/yzd/common/getDictItems',p)
//获取基础库指令组列表
export const getBaseCmdgroupinfos = p => post('/yzd/cmdgroupinfo/getBaseCmdgroupinfos',p)
//车主列表
export const queryCarownerinfoPage = p => post('/zd618/carownerinfo/queryCarownerinfoPage',p)
//修改用户状态
export const updateCarownerStatus = p => post('/zd618/carownerinfo/updateCarownerStatus',p)
//用户设备列表
export const queryZdVcidevicestatusPage = p => post('/zd618/device/queryZdVcidevicestatusPage',p)
//解绑设备
export const unbindDevice2 = p => post('/zd618/device/unbindDevice',p)
//批量解绑618设备
export const unbindDevice3 = p => post('/zd618/device/unbindbatchDevice',p)
//售机类型授权复用
export const authProductInfoCopy = p => post('/ckproductinfo/authProductInfoCopy',p)
//下载投诉日志
export const dfile = p => post('/complain/dfile',p)

// 商用车在线菜单
// 分页获取商用车ECU
export const dieselecuList = p => get('/cvmenu/dieselecu/queryPage',p)
// 增加商用车ECU
export const adddieselecu = p => postJson('/cvmenu/dieselecu/add',p)
// 修改商用车ECU
export const updatedieselecu = p => postJson('/cvmenu/dieselecu/update',p)
// 删除商用车ECU
export const deldieselecu = p => post('/cvmenu/dieselecu/del',p)

// 分页获取商用车ECU类型
export const dieselecutypeList = p => get('/cvmenu/dieselecutype/queryPage',p)
// 增加商用车ECU类型
export const adddieselecutype = p => postJson('/cvmenu/dieselecutype/add',p)
// 修改商用车ECU类型
export const updatedieselecutype = p => postJson('/cvmenu/dieselecutype/update',p)
// 删除商用车ECU类型
export const deldieselecutype = p => post('/cvmenu/dieselecutype/del',p)

// 分页获取车型系统菜单
export const dieselsysmenuList = p => get('/cvmenu/dieselsysmenu/queryPage',p)
// 增加车型系统菜单
export const adddieselsysmenu = p => postJson('/cvmenu/dieselsysmenu/add',p)
// 修改车型系统菜单
export const updatedieselsysmenu = p => postJson('/cvmenu/dieselsysmenu/update',p)
// 删除车型系统菜单
export const deldieselsysmenu = p => post('/cvmenu/dieselsysmenu/del',p)

// 分页获取商用车品牌
export const dieselbrandList = p => get('/cvmenu/dieselbrand/queryPage',p)
// 增加商用车品牌
export const adddieselbrand = p => postJson('/cvmenu/dieselbrand/add',p)
// 修改商用车品牌
export const updatedieselbrand = p => postJson('/cvmenu/dieselbrand/update',p)
// 删除商用车品牌
export const deldieselbrand = p => post('/cvmenu/dieselbrand/del',p)

// 分页获取商用车数据
export const dieseldataList = p => get('/cvmenu/dieseldata/queryPage',p)
// 增加商用车数据
export const adddieseldata = p => postJson('/cvmenu/dieseldata/add',p)
// 修改商用车数据
export const updatedieseldata = p => postJson('/cvmenu/dieseldata/update',p)
// 删除商用车数据
export const deldieseldata = p => post('/cvmenu/dieseldata/del',p)

// 分页获取商用车车组
export const dieselgroupList = p => get('/cvmenu/dieselgroup/queryPage',p)
// 增加商用车车组
export const adddieselgroup = p => postJson('/cvmenu/dieselgroup/add',p)
// 修改商用车车组
export const updatedieselgroup = p => postJson('/cvmenu/dieselgroup/update',p)
// 删除商用车车组
export const deldieselgroup = p => post('/cvmenu/dieselgroup/del',p)

// 分页获取车型系统菜单关系
export const sysmenulinkList = p => get('/cvmenu/sysmenulink/queryPage',p)
// 增加车型系统菜单关系
export const addsysmenulink = p => postJson('/cvmenu/sysmenulink/add',p)
// 修改车型系统菜单关系
export const updatesysmenulink = p => postJson('/cvmenu/sysmenulink/update',p)
// 删除车型系统菜单关系
export const delsysmenulink = p => post('/cvmenu/sysmenulink/del',p)

// 分页获取品牌图标
export const brandiconList = p => get('/cvmenu/brandicon/queryPage',p)
// 增加品牌图标
export const addbrandicon = p => postForm('/cvmenu/brandicon/add',p)
// 修改品牌图标
export const updatebrandicon = p => postForm('/cvmenu/brandicon/update',p)
// 删除品牌图标
export const delbrandicon = p => post('/cvmenu/brandicon/del',p)

// 分页获取品牌系统菜单
export const dieselbrandmenuList = p => get('/cvmenu/dieselbrandmenu/queryPage',p)
// 增加品牌系统菜单
export const adddieselbrandmenu = p => postJson('/cvmenu/dieselbrandmenu/add',p)
// 修改品牌系统菜单
export const updatedieselbrandmenu = p => postJson('/cvmenu/dieselbrandmenu/update',p)
// 删除品牌系统菜单
export const deldieselbrandmenu = p => postJson('/cvmenu/dieselbrandmenu/del',p)

// 分页获取车组品牌
export const dieselgroupbrandList = p => get('/cvmenu/dieselgroupbrand/queryPage',p)
// 增加车组品牌
export const adddieselgroupbrand = p => postJson('/cvmenu/dieselgroupbrand/add',p)
// 修改车组品牌
export const updatedieselgroupbrand = p => postJson('/cvmenu/dieselgroupbrand/update',p)
// 删除车组品牌
export const deldieselgroupbrand = p => postJson('/cvmenu/dieselgroupbrand/del',p)

// 分页获取进入功能描述
export const entrymaskList = p => get('/cvmenu/entrymask/queryPage',p)
// 增加进入功能描述
export const addentrymask = p => postJson('/cvmenu/entrymask/add',p)
// 修改进入功能描述
export const updateentrymask = p => postJson('/cvmenu/entrymask/update',p)
// 删除进入功能描述
export const delentrymask = p => post('/cvmenu/entrymask/del',p)

// 分页获取多音字词组
export const polyphonewordList = p => get('/cvmenu/polyphoneword/queryPage',p)
// 增加多音字词组
export const addpolyphoneword = p => postJson('/cvmenu/polyphoneword/add',p)
// 修改多音字词组
export const updatepolyphoneword = p => postJson('/cvmenu/polyphoneword/update',p)
// 删除多音字词组
export const delpolyphoneword = p => post('/cvmenu/polyphoneword/del',p)

// 从mysql中查询数据生成Sqlite数据库，并进行加密，更新sqlite版本号，压缩后上传到OSS
export const diagnosisdb1genDb  = p => post('/cvmenu/diagnosisdb1/genDb',p)
// 生成7z包，上传OSS，并更新升级通道
export const diagnosisdb1zip  = p => post('/cvmenu/diagnosisdb1/zip',p)

// 获取商用车ECU类型列表
export const dieselecutypeLists  = p => get('/cvmenu/dieselecutype/queryList',p)
// 获取商用车车组列表
export const dieselgroupLists  = p => get('/cvmenu/dieselgroup/queryList',p)
// 获取商用车ECU列表
export const dieselecuLists  = p => get('/cvmenu/dieselecu/queryList',p)
// 获取车型系统菜单列表
export const dieselsysmenuLists  = p => get('/cvmenu/dieselsysmenu/queryList',p)
// 获取商用车品牌列表
export const dieselbrandLists  = p => get('/cvmenu/dieselbrand/queryList',p)

// 分页获取菜单数据包未授权品牌车型
export const menupackbrandUnauth  = p => get('/cvmenu/menupackbrand/queryUnauthPage',p)
// 分页获取菜单数据包已授权品牌车型
export const menupackbrandAuth  = p => get('/cvmenu/menupackbrand/queryAuthPage',p)
// 增加菜单数据包授权品牌车型
export const menupackbrandaddAuth  = p => postJson('/cvmenu/menupackbrand/addAuth',p)
// 修改菜单数据包授权品牌车型
export const menupackbrandupdateAuth  = p => postJson('/cvmenu/menupackbrand/updateAuth',p)
// 删除菜单数据包授权品牌车型
export const menupackbranddelAuth  = p => postJson('/cvmenu/menupackbrand/delAuth',p)

// 分页获取菜单数据包的车组
export const menupackgroupList  = p => get('/cvmenu/menupackgroup/queryPage',p)
// 修改菜单数据包的车组排序
export const menupackgroupupdate = p => postJson('/cvmenu/menupackgroup/update',p)

// 分页获取菜单包系统菜单
export const packmenuList = p => get('/cvmenu/packmenu/queryPage',p)
// 增加菜单包系统菜单
export const packmenuadd = p => postJson('/cvmenu/packmenu/add',p)
// 删除菜单包系统菜单
export const packmenudel = p => postJson('/cvmenu/packmenu/del',p)

// 菜单数据包分页查询
export const findChildTypePage = p => get('/otherfile/findChildTypePage',p)
// 菜单数据包新增
export const addFileOtherdownchildInfo = p => postJson('/otherfile/addFileOtherdownchildInfo',p)
// 菜单数据包修改
export const updateFileOtherdownchildInfo = p => postJson('/otherfile/updateFileOtherdownchildInfo',p)

// 分页获取子文件授权售机类型
export const findProductInfo4FilechildInfoPage = p => get('/otherfile/findProductInfo4FilechildInfoPage',p)
// 子文件授权售机类型
export const authProductInfoOtherdownchildtype2 = p => get('/otherfile/authProductInfoOtherdownchildtype',p)
// 取消子文件授权售机类型
export const unauthProductInfoOtherdownchildtype2 = p => get('/otherfile/unauthProductInfoOtherdownchildtype',p)

// 导入车型系统菜单
export const importDieselSysmenus = p => post('/cvmenu/dieselsysmenu/importDieselSysmenus',p)

// 分页获取vci与平板绑定关系
export const motorcycleList = p => get('/motorcycle/queryPage',p)
// 解绑
export const unbindmotorcycle = p => post('/motorcycle/unbind',p)
// 绑定
export const bindmotorcycle = p => post('/motorcycle/bind',p)
// 更换VCI
export const replaceVci = p => post('/motorcycle/replaceVci',p)
// 分页获取vci绑定记录
export const queryBindRecPage = p => get('/motorcycle/queryBindRecPage',p)
// 分页获取vci更换记录
export const queryVciReplacePage = p => get('/motorcycle/queryVciReplacePage',p)
// 修改vci与平板绑定
export const updateMotorcycle = p => post('/motorcycle/updateMotorcycle',p)

// 获取换机类型或机器属性
export const dicType = p => get('/change/dicType',p)
// 分页获取换机数据列表
export const showMachine = p => get('/change/showMachine',p)
// 增加换机数据
export const addMachine = p => postJson('/change/addMachine',p)
// 修改换机数据
export const editMachine = p => post('/change/editMachine',p)
// 删除换机数据
export const delMachine = p => get('/change/delMachine',p)

// 分页获取DLL方法调用设置
export const dllcallSetPage = p => get('/dllcallSet/queryPage',p)
// 刷新DLL方法调用验证码
export const refreshDllCallPw = p => post('productall/refreshDllCallPw',p)
// 刷新DLL方法调用验证码
export const refreshValidateCode = p => post('dllcallSet/refreshDllCallPw',p)
// 增加DLL方法调用设置
export const adddllcallSet = p => post('/dllcallSet/add',p)
// 修改DLL方法调用设置
export const updatedllcallSet = p => post('/dllcallSet/update',p)
// 分页获取DLL方法调用记录
export const queryDllcallRecPage = p => get('/dllcallSet/queryDllcallRecPage',p)
// 分页获取dll算法验证码列表
export const listDllCallInfo = p => get('/dllcallSet/listDllCallInfo',p)

// 批量获取智断投诉的日志链接
export const batchAttachbycomplains = p => get('/complain/batchAttachbycomplains',p)
// 解绑zd618车辆
export const unbindCarById = p => post('/zd618/carmanage/unbindCarById',p)


// 设备序列号过期日期修改记录列表
export const queryExpirePage = p => get('/clientLogProduct/queryExpirePage',p)
// 导出：设备序列号过期日期修改记录
export const exportExpirelog = p => get('/clientLogProduct/exportExpirelog',p)






// WEBPACK FOOTER //
// ./src/assets/ajax/api.js